import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserLoginComponent } from './components/user-login/user-login.component';
import { UserLogoutComponent } from './components/user-logout/user-logout.component';
import { UserLandingComponent } from './components/user-landing/user-landing.component';
import { DataPagePOComponent } from './components/data-page-po/data-page-po.component';
import { DataPageTimesheetComponent } from './components/data-page-timesheet/data-page-timesheet.component';
import { DataPageContractorComponent } from './components/data-page-contractor/data-page-contractor.component';
import { PageContractorsComponent } from './components/page-contractors/page-contractors.component';
import { PagePosComponent } from './components/page-pos/page-pos.component';
import { PageSmartContractsComponent } from './components/page-smart-contracts/page-smart-contracts.component';
import { PageTimesheetsComponent } from './components/page-timesheets/page-timesheets.component';
import { AdminPOComponent } from './components/admin-po/admin-po.component';
import { PagePoReplacementComponent } from './components/page-po-replacement/page-po-replacement';
import { AdminAddonsComponent } from './components/admin-addons/admin-addons.component';
import { PageInvoicesComponent } from './components/page-invoices/page-invoices.component';
import { PrivacyNoticeComponent } from './components/privacy-notice/privacy-notice.component';
import { AdminInvoiceComponent } from './components/admin-invoice/admin-invoice.component';
import { TimesheetLineItemsComponent } from './components/timesheet-line-item/timesheet-line-item.component';
import { AdminUsersComponent } from './components/admin-users/admin-users.component';
import { UserAcceptComponent } from './components/user-accept/user-accept.component';
import { PageInvoiceCalendarsComponent } from './components/page-invoice-calendars/page-invoice-calendars.component';
import { HelpComponent } from './components/help/help.component';
import { AdminSupInvoiceComponent } from './components/admin-sup-invoice/admin-sup-invoice.component';
import { DataPageUserComponent } from './components/data-page-user/data-page-user.component';
import { UserConfigComponent } from './components/user-config/user-config.component';
import { PageSupplierInvoicesComponent } from './components/page-supplier-invoices/page-supplier-invoices.component';
import { PageReportsComponent } from './components/page-reports/page-reports.component';
import { SaConfigComponent } from './components/sa-config/sa-config.component';
import { PageBlockchainInvoicesComponent } from './components/page-blockchain-invoices/page-blockchain-invoices.component';
import { DataPageSupplierInvoiceComponent } from './components/data-page-supplier-invoice/data-page-supplier-invoice.component';
import { DataPageBcinvoiceComponent } from './components/data-page-bcinvoice/data-page-bcinvoice.component';
import { DataPageInvoiceComponent } from './components/data-page-invoice/data-page-invoice.component';
import { PageDtvScheduleComponent } from './components/page-dtv-schedule/page-dtv-schedule.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ReleaseNotesComponent } from './components/release-notes/release-notes.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { LoginHelpComponent } from './components/login-help/login-help.component';


const AppRoutes: Routes = [
	{
		path: '',
		component: UserLandingComponent
	}, {
		path: 'home',
		component: UserLandingComponent
	}, {
		path: 'timesheet',
		component: UserLandingComponent
	}, {
		path: 'help',
		component: HelpComponent
	}, {
		path: 'logout',
		component: UserLogoutComponent
	}, {
		path: 'reset-password',
		component: ResetPasswordComponent
	}, {
		path: 'purchase-orders',
		component: PagePosComponent
	}, {
		path: 'purchase-orders/:initTab',
		component: PagePosComponent
	}, {
		path: 'purchase-order/:poNumber/:supplierId',
		component: DataPagePOComponent
	}, {
		path: 'contractors',
		component: PageContractorsComponent
	}, {
		path: 'contractors/:initTab',
		component: PageContractorsComponent
	}, {
		path: 'contractor/:poNumber/:contractorId/:supplierId',
		component: DataPageContractorComponent
	}, {
		path: 'contract-changes',
		component: PageSmartContractsComponent
	}, {
		path: 'timesheets',
		component: PageTimesheetsComponent
	}, {
		path: 'timesheets/:initTab',
		component: PageTimesheetsComponent
	}, {
		path: 'timesheet/:poNumber/:contractorId/:supplierId/:loadDate',
		component: DataPageTimesheetComponent
	}, {
		path: 'timesheet/:poNumber/:contractorId/:supcontId/:supplierId/:loadDate',
		component: DataPageTimesheetComponent
	}, {
		path: 'admin-po',
		component: AdminPOComponent
	}, {
		path: 'admin-invoice',
		component: AdminInvoiceComponent
	}, {
		path: 'admin-sup-invoice',
		component: AdminSupInvoiceComponent
	}, {
		path: 'admin-users',
		component: AdminUsersComponent
	}, {
		path: 'admin-addons',
		component: AdminAddonsComponent
	}, {
		path: 'replacement',
		component: PagePoReplacementComponent
	}, {
		path: 'escalation-config',
		component: SaConfigComponent
	}, {
		path: 'invoices',
		component: PageInvoicesComponent
	}, {
		path: 'invoices/:initTab',
		component: PageInvoicesComponent
	}, {
		path: 'supplier-invoices',
		component: PageSupplierInvoicesComponent
	}, {
		path: 'supplier-invoices/:initTab',
		component: PageSupplierInvoicesComponent
	}, {
		path: 'blockchain-invoices',
		component: PageBlockchainInvoicesComponent
	}, {
		path: 'blockchain-invoices/:initTab',
		component: PageBlockchainInvoicesComponent
	}, {
		path: 'privacy-notice',
		component: PrivacyNoticeComponent
	}, {
		path: 'dashboard',
		component: DashboardComponent
	}, {
		path: 'timesheet-line-items',
		component: TimesheetLineItemsComponent
	}, {
		path: 'accept-account/:acceptToken',
		component: UserAcceptComponent
	}, {
		path: 'invoice-calendars',
		component: PageInvoiceCalendarsComponent
	}, {
		path: 'user',
		component: DataPageUserComponent
	}, {
		path: 'user-config',
		component: UserConfigComponent
	}, {
		path: 'reports',
		component: PageReportsComponent
	}, {
		path: 'reports/:initTab',
		component: PageReportsComponent
	}, {
		path: 'invoice/:poNumber/:supplierId/:billingStart/:billingEnd',
		component: DataPageInvoiceComponent
	}, {
		path: 'supplier-invoice/:poNumber/:invoiceNumber/:supplierId',
		component: DataPageSupplierInvoiceComponent
	}, {
		path: 'blockchain-invoice/:poNumber/:supplierId/:billingStart/:billingEnd/:invoiceType/:contractorUUID',
		component: DataPageBcinvoiceComponent
	}, {
		path: 'blockchain-invoice/:poNumber/:supplierId/:billingStart/:billingEnd/:invoiceType',
		component: DataPageBcinvoiceComponent
	}, {
		path: 'delegated-time-verifier-schedule',
		component: PageDtvScheduleComponent
	}, {
		path: 'release-notes',
		component: ReleaseNotesComponent
	}, {
		path: 'login-help',
		component: LoginHelpComponent
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(AppRoutes, { relativeLinkResolution: 'legacy' })
	],
	exports: [
		RouterModule
	]
})

export class AppRouting { }
